import React, { useRef, useState, useEffect } from "react";
import Timezone from "../../Utils/Data/timezone.json";
import {
  LoginContainer,
  RightSide,
  FormWrapper,
} from "./loginStyles/login.style";
import { useLocation } from "react-router-dom";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Controller, useForm } from "react-hook-form";
import LoginLeft from "../../assets/loginLeft.png";
import LoginRight from "../../assets/loginRight.png";
import LoginPhoto from "../../assets/loginBackground.jpg";
import StrinLocalized from "../../Language/language.lang";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axiosInstance from "../../HelperAxios/axios";
import { API_URL } from "../../HelperAxios/const";
import {
  Stack,
  FormGroup,
  FormLabel,
  TextField,
  Box,
  Typography,
  Button,
} from "@mui/material";
import { ThemeProvider } from "@mui/material";
import theme from "../../Layout/layoutThemeConfig/layoutThemeConfig.theme";
import Footer from "../../components/Footer/footer.component";
import UploadInput from "../../components/Inputs/UploadInput/UploadInput.component";

const RegisterSubscriptionForRole = () => {
  const { handleSubmit, control } = useForm();
  //   const [searchParams, setSearchParams] = useSearchParams();
  //   const [visible, setVisible] = useState(false);

  //   const [pic, setPic] = useState();
  //   const showPasswordHandler = () => {
  //     setVisible(!visible);
  //   };
  //   localStorage.removeItem("token-siraj");

  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  const onSubmit = (data) => {
    // const token = captchaRef.current.getValue();
    // const Data = {
    //   username: data.username,
    //   name: data.name,
    //   mobileNumber: `${data.mobileNumber}`,
    //   email: data.email,
    //   timeZone: data.timeZone?.value,
    //   password: data.password,
    //   "g-recaptcha-response": recaptchaRef.current.getValue(),
    // };
    // toast.info(StrinLocalized.SendingData);
    // axiosInstance
    //   .post(API_URL + "user/create/free", {
    //     ...Data,
    //     role: 2,
    //     status: "active",
    //     subscription: Number(searchParams.get("subscription")),
    //   })
    //   .then((res) => {
    //     toast.success(StrinLocalized.SuccessLogin);
    //     captchaRef.current.reset();
    //   })
    //   .catch((err) => {
    //     if (typeof err.response.data.message === "string") {
    //       toast.error(err.response.data.message);
    //     } else {
    //       toast.error(err.response.data.message[0]);
    //     }
    //   });
  };

  const UploadPic = async (data) => {
    // const formData = new FormData();
    // formData.append("file", data);
    // toast.info(StrinLocalized.SendingData);
    // await axiosInstance
    //   .post(`upload`, formData, {
    //     headers: { "Content-Type": "multipart/form-data" },
    //   })
    //   .then((res) => {
    //     toast.success(res.statusText);
    //     setPic(res.data.filename);
    //   })
    //   .catch((err) => {
    //     toast.error(err.response.data.message);
    //     return err;
    //   });
  };

  return (
    <ThemeProvider theme={theme}>
      <LoginContainer backgroundPhoto={LoginPhoto} sx={{ height: "160vh" }}>
        <img
          style={{ position: "absolute", left: 0, bottom: 0 }}
          src={LoginLeft}
        ></img>
        <img
          style={{ position: "absolute", right: 0, bottom: 0 }}
          src={LoginRight}
        ></img>
        <Typography
          fontWeight="bold"
          variant="h3"
          sx={{
            background: "linear-gradient(#0018D4, #CF00BA)",
            backgroundClip: "text",
            WebkitTextFillColor: "transparent",
            width: "600px",
            marginInline: "auto",
            padding: "30px",
          }}
        >
          {StrinLocalized.Subscription}
        </Typography>{" "}
        <RightSide>
          <FormWrapper>
            <form style={{ width: "100%" }} onSubmit={handleSubmit(onSubmit)}>
              <Stack width="100%" gap={4}>
                <Box display="flex" justifyContent="space-between">
                  <Typography variant="subtitle2" color="white">
                    {StrinLocalized.PleaseSetyourSubscription}
                  </Typography>
                  <Typography variant="subtitle2" color="white">
                  {StrinLocalized.Subscription}
                  </Typography>
                </Box>

                <Controller
                  name="subscriberName"
                  control={control}
                  render={({ field: { onChange, value = "" } }) => (
                    <FormGroup>
                      <FormLabel
                        sx={{ marginBottom: "5px", fontWeight: "bold" }}
                      >
                        {StrinLocalized.Subscription}
                      </FormLabel>
                      <TextField
                        id="email"
                        type="text"
                        name="email"
                        onChange={onChange}
                        value={value}
                        sx={{
                          "&  .MuiInputBase-root,& .MuiTextField-root": {
                            bgcolor: "white",
                          },
                          "& fieldset": {
                            border: "none",
                          },
                        }}
                        variant="outlined"
                        placeHolder={StrinLocalized.Subscription}
                      />
                    </FormGroup>
                  )}
                />
                <Controller
                  name="subscriberName"
                  control={control}
                  render={({ field: { onChange, value = "" } }) => (
                    <FormGroup>
                      <FormLabel
                        sx={{ marginBottom: "5px", fontWeight: "bold" }}
                      >
                        {StrinLocalized.Subscription}
                      </FormLabel>
                      <UploadInput
                        sx={{
                          "& .MuiInputBase-root": {
                            bgcolor: "white",
                            color: "white", // Set text color to white
                          },
                          "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline":
                            {
                              border: "none",
                            },
                          "& .MuiInputBase-input": {
                            color: "white", // Set text color to white inside the input
                          },
                        }}
                        onChange={onChange}
                        value={value}
                        index={0}
                        uploadPic={UploadPic}
                      />
                    </FormGroup>
                  )}
                />

                <Button
                  size="large"
                  type="submit"
                  variant="contained"
                  sx={{
                    bgcolor: "#9D2778",
                    "&:hover": { bgcolor: "#9D2778" },
                  }}
                >
                  {StrinLocalized.Register}
                </Button>
              </Stack>
            </form>
          </FormWrapper>
        </RightSide>
      </LoginContainer>
      <ToastContainer rtl={false} />
      <Footer />
    </ThemeProvider>
  );
};

export default RegisterSubscriptionForRole;
